/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
import { IconArrowDown, IconRadioChecked, IconRadioUnchecked } from './Icons';

/* ===========================
CLASS
=========================== */
class ButtonDropdownColumns extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      id: (this.props.id || `dropdown-${Math.random().toString(36).slice(2)}`),
      loading: this.props.loading || false,
      label: (this.props.label || 'Dropdown button'),
      style: (this.props.optinonsStyle || 'btn-secondary'),
      options: (this.props.options || {}),
      classes: (this.props.classes || ''),
      open: false,
      prevProps: {},
    };

    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * @param {object} nextProps
   * @param state
   */
  // eslint-disable-next-line consistent-return
  static getDerivedStateFromProps(nextProps, state) {
    const { prevProps } = state;

    if (prevProps.id !== nextProps.id) return prevProps;

    if (nextProps.options && Object.keys(nextProps.options).length > 0) {
      return {
        loading: (nextProps.loading || false),
        options: (nextProps.options || {}),
        prevProps: nextProps,
      };
    }

    if (nextProps.options && Object.keys(nextProps.options).length <= 0) {
      return {
        options: {},
        prevProps: nextProps,
      };
    }
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {Event} event
   */
  handleClick(event) {
    if (this.state.options && Object.keys(this.state.options).length > 0) {
      this.setState((prevState) => ({
        open: !prevState.open,
      }));
    }

    event.preventDefault();
  }

  /**
   * @param {Event} event
   * @param {string} key
   */
  onUpdateCheck(event, key) {
    const columns = this.state.options;
    columns[key].visible = !columns[key].visible;
    this.props.onUpdateChecks(columns, key, columns[key].visible);

    event.preventDefault();
  }

  /**
   * @param {object} options
   */
  static getShowing(options) {
    let count = 0;
    Object.keys(options).map((item) => {
      if (options[item].visible === true) {
        count += 1;
      }
      return item;
    });
    return count;
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div className={`dropdown${((this.state.open) ? ' show' : '')} ${this.state.classes}`}>
        <span className="dropdown-showing">
          {ButtonDropdownColumns.getShowing(this.state.options)}
          {' '}
          of
          {' '}
          {Object.keys(this.state.options).length}
          {' '}
          columns
        </span>
        {/* BUTTON */}
        <button
          disabled={this.state.loading || Object.keys(this.state.options).length <= 0}
          className={`btn ${this.state.style}`}
          type="button"
          id={this.state.id}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={this.handleClick}
        >
          <span>{this.state.label}</span>
          <IconArrowDown />
        </button>
        {/* end BUTTON */}

        {/* DROPDOWN */}
        <div className={`dropdown-menu${((this.state.open && !this.state.loading) ? ' show' : '')}`} aria-labelledby={this.state.id}>
          <div className="dropdown-menu-inner">
            {(this.state.options && Object.keys(this.state.options).length > 0)
              ? (Object.keys(this.state.options).map((key) => (
                <a key={key} onClick={(e) => this.onUpdateCheck(e, key)} className="dropdown-item" href={`#${key}`}>
                  {(this.state.options[key].visible)
                    ? (<IconRadioChecked />)
                    : (<IconRadioUnchecked />)}
                  {(this.state.options[key].label) ? this.state.options[key].label : key}
                </a>
              )))
              : null}
          </div>
        </div>
        {/* end DROPDOWN */}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ButtonDropdownColumns.propTypes = {
  id: PropTypes.string,
  loading: PropTypes.bool,
  label: PropTypes.string,
  optinonsStyle: PropTypes.string,
  options: PropTypes.object,
  classes: PropTypes.string,
  onUpdateChecks: PropTypes.func,
};

/* ===========================
EXPORT
=========================== */
export default ButtonDropdownColumns;
